import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { filter, take } from "rxjs";
import { PieChartComponent } from "../../../../components/chart/pie-chart/pie-chart.component";
import { NoDataComponent } from "../../../../components/common/no-data/no-data.component";
import { SharedComponents } from "../../../../components/shared.module";
import { selectMappingResponse } from "../../../../core/ngrx/selectors/test-prioritization.selectors";
import { RestService } from "../../../../core/services/rest.service";

/**
 * Component responsible for displaying code coverage information using a pie chart.
 * It retrieves mapping responses and test case coverage data from the backend.
 */
@Component({
  selector: "app-code-coverage",
  standalone: true,
  imports: [PieChartComponent, NoDataComponent, ...SharedComponents],
  templateUrl: "./code-coverage.component.html",
  styleUrl: "./code-coverage.component.scss",
})
export class CodeCoverageComponent implements OnInit {
  mappingResponse$ = this.store.select(selectMappingResponse);
  mappingId: any = "";
  chartData: any = {};
  coverage: number = 66;
  bgColors = ["#55A62E", "#CDCCCC"];
  loading: boolean = false;
  suite:string = "";
  /**
   * Constructor to inject required services.
   *
   * @param store The NgRx store for accessing state and dispatching actions.
   * @param restService The service used to make HTTP requests to the backend.
   */
  constructor(private store: Store, private restService: RestService) {}

  /**
   * Lifecycle hook that runs on component initialization.
   * Subscribes to the mapping response observable and triggers the coverage data loading.
   */
  ngOnInit() {
    this.mappingResponse$
      .pipe(
        filter((response) => !!response),
        take(1)
      )
      .subscribe((response) => {
        console.log("Response received in component:", response);
        this.mappingId = response.id;
        this.loadCoverage();
      });
  }

  /**
   * Loads test case coverage data from the backend and updates the chart data.
   * Sets loading state to true while fetching data and updates UI after response or error.
   */
  loadCoverage() {
    this.loading = true;
    this.restService.getTestCaseCoverage(this.mappingId).subscribe(
      (item) => {
        console.log("COVERAGE", item);
        this.suite = item?.data?.test_suite_name;
        this.coverage = item?.data?.latest_coverage;
        this.chartData = {
          Covered: {
            defect: item?.data?.latest_coverage,
          },
          "Un-Covered": {
            defect: 100 - item?.data?.latest_coverage,
          },
        };
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
  }
}
